import script from "./MembersView.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersView.vue?vue&type=script&setup=true&lang=js"

import "./MembersView.vue?vue&type=style&index=0&id=7bcd1f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bcd1f3c"]])

export default __exports__